<template>
  <div>
    <page-header
      v-if="!isNativeAppRequest"
      :locale="appLocale"
      :is-order-count-supported="false"
      :show-delivery-enquiry="false"
      :show-offers-link="false"
      :user-info-prop="userInfoData"
    />
    <div class="consumerHelpApp">
      <div v-if="$route.name !== 'PageNotFound'">
        <user-message :locale="appLocale" data-test="userMessage" />
        <!-- [Below avoids reload on navigation `/help` & `/help/other-questions`]  -->
        <!-- Featured Articles -->
        <div
          v-if="isPersonalisationRoute($route.name) && !personalisationEnabled"
          class="l-container c-featArticlesContainer"
        >
          <div class="l-container--inner c-featArticlesContainer">
            <div>
              <non-personalised-page-heading v-once />
              <featured-articles :feat-articles="featuredArticles" />
            </div>
          </div>
        </div>
        <!-- Personalisation -->
        <personalised-help
          v-if="isPersonalisationRoute($route.name) && personalisationEnabled"
          v-once
        />
      </div>
      <!-- Route -->
      <router-view />
    </div>
    <page-footer v-if="!isNativeAppRequest" :locale="appLocale" :content="footerContent" />
    <vue-cookie-banner v-if="(!isNativeAppRequest && tenant !== 'au')" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeader from '@justeat/f-header'
import UserMessage from '@justeat/f-user-message'
import PersonalisedHelp from './components/PersonalisedHelp.vue'
import NonPersonalisedPageHeading from './components/NonPersonalisedPageHeading.vue'
import FeaturedArticles from './components/FeaturedArticles.vue'
import ConfigService from './services/ConfigService'
import logger from './utilities/logger'

import './styles/index.scss'
import '@justeat/f-header/dist/f-header.css'
import '@justeat/f-user-message/dist/f-user-message.css'
import '@justeat/f-footer/dist/f-footer.css'

export default {
  name: 'HelpApp',
  components: {
    PageHeader,
    PageFooter: () => import(/* webpackChunkName: "vue-footer" */ '@justeat/f-footer'),
    UserMessage,
    VueCookieBanner: () => import(/* webpackChunkName: "vue-cookie-banner" */ './components/VueCookieBanner.vue'),
    PersonalisedHelp,
    NonPersonalisedPageHeading,
    FeaturedArticles
  },
  computed: {
    ...mapGetters([
      'appLocale',
      'personalisationEnabled',
      'featuredArticles',
      'footerContent',
      'isNativeAppRequest',
      'tenant',
      'userInfoData'
    ])
  },
  created() {
    this.$store.dispatch('fetchLocale')
    this.$store.dispatch('snowplow/setGlobalContext', this.$route.name)
    this.$store.dispatch('fetchArticles')
    this.$store.dispatch('fetchFooterContent')
    if (!ConfigService.personalisationEnabled()) {
      // Content required by personalisation fallabck
      this.$store.dispatch('useFallbackForTopLevelActions')
    }

    logger.info('Application loaded')
  },
  methods: {
    isPersonalisationRoute(route) {
      return route === 'help' || route === 'other-questions'
    },
    displayPersonlisationFallback(route) {
      return route === 'help' || route === 'other-questions'
    }
  }
}
</script>
